<div class="checkbox-container">
  <div class="custom-checkbox">
    <label>
      <input
        #checkboxInput
        type="checkbox"
        [ngClass]="{ error: error }"
        [name]="name"
        [value]="value"
        [disabled]="disabled"
        [indeterminate]="indeterminate"
        [checked]="checked"
        (change)="onCheckboxChange($event)"
      />
      <span class="checkmark">
        <ds-icon icon="check" class="check-icon"></ds-icon>
        <ds-icon icon="minus-a" class="indeterminate-icon"></ds-icon>
      </span>
    </label>
    <span *ngIf="label" class="label" [class.label-disabled]="disabled">{{ label }}</span>
  </div>
  <span *ngIf="error" class="error-message">{{ errorMessage }}</span>
</div>
